import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { ProdutosPlanilhaProvider } from "../../../contexts/ProdutosPlanilha/ProdutosPlanilhaProvider";
import Swal from "sweetalert2";

interface ImportarProdutosNovo {
  permissoesPlanos: string[];
}

const ImportarProdutos: React.FC<ImportarProdutosNovo> = ({
  permissoesPlanos,
}) => {
  const permissoesCarregadas = permissoesPlanos && Object.keys(permissoesPlanos).length > 0;
  const temPermissao = permissoesPlanos?.["IMPORTACAO_DE_PRODUTOS_EM_MASSA_POR_PLANILHA_DE_EXCEL"]?.permitido;

  useEffect(() => {
    if (permissoesCarregadas && !temPermissao) {
      Swal.fire({
        icon: "warning",
        title: "Acesso negado",
        text: "Você não tem permissão para acessar essa página",
      }).then(() => {
        setTimeout(() => {
          window.location.href = "/";
        }, 5000);
      });
    }
  }, [permissoesCarregadas, temPermissao]);

  if (!permissoesCarregadas || !temPermissao) {
    return null;
  }

  return (
    <>
      <ProdutosPlanilhaProvider>
        <Outlet />
      </ProdutosPlanilhaProvider>
    </>
  );
};

export default ImportarProdutos;
